export default {
  welcomeText: "Welcome to the virtual tour of",
  title: "The <i>Vertical</i> farm",
  name: `loading_screen`,
  loadingText: `Loading`,
  description: "",
  start: "Start",
};
